/* eslint-disable react/jsx-no-useless-fragment */
import { Drawer, SvgIcon, Text, TextLink } from '@cinch-labs/design-system'
import {
  EventNames,
  TrackingEventTypes,
  useAnalytics,
} from '@cinch-nx/shared-analytics'
import { useEffect } from 'react'
import styles from './options-explained-drawer.module.css'
import { useServiceOptionsExplainedDrawer } from './options-explained-drawer.context'

export const ServiceOptionsExplainedDrawer = () => {
  const { trackEvent } = useAnalytics()
  useEffect(() => {
    const parExchangeLoadModalEvent = {
      eventName: `Load service options explained modal`,
      type: TrackingEventTypes.ADOBE,
      data: {
        event: {
          name: EventNames.load,
          category: 'modal',
          action: EventNames.load,
          label: 'cinch-servicing',
          value: 'service-options-explained-cinch-servicing',
        },
      },
    }
    trackEvent(parExchangeLoadModalEvent)
  }, [])

  const {
    isEv,
    setShowServiceOptionsExplainedDrawer,
    showServiceOptionsExplainedDrawer,
  } = useServiceOptionsExplainedDrawer()

  const handleClick = () => {
    setShowServiceOptionsExplainedDrawer(!showServiceOptionsExplainedDrawer)
  }

  const drawerContent = isEv ? (
    <div className={styles.container}>
      <Text fontSizeFixed="s" fontWeight="bold">
        MOT - £39.95
      </Text>
      <Text fontSizeFixed="s">(Every 12 months)</Text>
      <br />
      <br />

      <Text fontSizeFixed="s" fontWeight="bold">
        Standard electric vehicle (EV) service - £159.95
      </Text>
      <Text fontSizeFixed="s">(Every 10-12,000 miles)</Text>
      <br />
      <Text>Includes:</Text>
      <ul style={{ listStyleType: 'disc', paddingLeft: '1.5em', margin: 0 }}>
        <li>Full diagnostics and software update(s) (if applicable)</li>
        <li>
          EV inspection (high-voltage components, cables, socket, battery
          charging status)
        </li>
        <li>Remove wheels, lubricate hubs, torque to spec</li>
        <li>Set tyre pressures</li>
        <li>Road test</li>
        <li>24-point check</li>
      </ul>
      <br />
      <br />

      <Text fontSizeFixed="s" fontWeight="bold">
        Major electric vehicle (EV) service - £214.95
      </Text>
      <Text fontSizeFixed="s">(Every 20-24,000 miles)</Text>
      <br />
      <Text>Includes:</Text>
      <ul style={{ listStyleType: 'disc', paddingLeft: '1.5em', margin: 0 }}>
        <li>Full diagnostics and software update(s) (if applicable)</li>
        <li>
          EV inspection (high-voltage components, cables, socket, battery
          charging status)
        </li>
        <li>Cabin air filter change</li>
        <li>Remove wheels, lubricate hubs, torque to spec</li>
        <li>Set tyre pressures</li>
        <li>Road test</li>
        <li>26-point check</li>
      </ul>
      <br />

      <div className={styles.textLink}>
        <TextLink
          href="/cinch-servicing/cinchservicing_at_marshall_terms.pdf"
          target="_blank"
          rel="nofollow noreferrer"
        >
          <SvgIcon name="new-tab" id="cinchServicing-terms-and-conditions" />
          Terms and conditions.
        </TextLink>
      </div>
      <br />
    </div>
  ) : (
    <div className={styles.container}>
      <Text fontSizeFixed="s" fontWeight="bold">
        MOT - £39.95
      </Text>
      <Text fontSizeFixed="s">(Every 12 months)</Text>
      <br />
      <br />

      <Text fontSizeFixed="s" fontWeight="bold">
        Oil & filter - £129.95
      </Text>
      <Text fontSizeFixed="s">(Every 5-7,000 miles)</Text>
      <br />
      <Text>Includes:</Text>
      <ul style={{ listStyleType: 'disc', paddingLeft: '1.5em', margin: 0 }}>
        <li>Engine oil and oil filter change</li>
        <li>Top-up screenwash and other fluids (excluding coolant)</li>
        <li>15-point check</li>
      </ul>
      <br />
      <br />

      <Text fontSizeFixed="s" fontWeight="bold">
        Standard service - £159.95
      </Text>
      <Text fontSizeFixed="s">(Every 10-12,000 miles)</Text>
      <br />
      <Text>Includes:</Text>
      <ul style={{ listStyleType: 'disc', paddingLeft: '1.5em', margin: 0 }}>
        <li>Engine oil and oil filter change</li>
        <li>Top-up screenwash, coolant and other fluids</li>
        <li>Reset tyre pressures</li>
        <li>Road test</li>
        <li>25-point check</li>
      </ul>
      <br />
      <br />

      <Text fontSizeFixed="s" fontWeight="bold">
        Major service - £214.95
      </Text>
      <Text fontSizeFixed="s">(Every 20-24,000 miles)</Text>
      <br />
      <Text>Includes:</Text>
      <ul style={{ listStyleType: 'disc', paddingLeft: '1.5em', margin: 0 }}>
        <li>Engine oil and oil filter change</li>
        <li>Air filter change</li>
        <li>Top-up screenwash, coolant and other fluids</li>
        <li>Check and adjust clutch</li>
        <li>Reset tyre pressures</li>
        <li>Road test</li>
        <li>29-point check</li>
      </ul>
      <br />

      <div className={styles.textLink}>
        <TextLink
          href="/cinch-servicing/cinchservicing_at_marshall_terms.pdf"
          target="_blank"
          rel="nofollow noreferrer"
        >
          <SvgIcon name="new-tab" id="cinchServicing-terms-and-conditions" />
          Terms and conditions.
        </TextLink>
      </div>
      <br />
    </div>
  )

  return (
    <>
      {showServiceOptionsExplainedDrawer && (
        <Drawer
          onClose={() => handleClick()}
          header={'Service options explained'}
          ariaLabelledById="service-options-explained-drawer"
        >
          {drawerContent}
        </Drawer>
      )}
    </>
  )
}

export default ServiceOptionsExplainedDrawer
